function daysFromNow(delta: number): string {
  const d = new Date();
  d.setDate(d.getDate() + delta);
  return d.toISOString();
}

function dateFromNow(delta: number): string {
  return daysFromNow(delta).slice(0, 10);
}

function monthsAgo(delta: number): string {
  const d = new Date();
  d.setMonth(d.getMonth() - delta);
  return d.toISOString().slice(0, 7);
}

function epochSecondsFromNow(days: number): number {
  return Math.floor((Date.now() + days * 86_400_000) / 1000);
}

export const mockAssignedCompanies = {
  data: [
    { companyId: 'cmp-1', name: 'Przykładowa Firma sp. z o.o.', nip: '5260001246' },
    { companyId: 'cmp-2', name: 'Beta Handel sp.j.', nip: '7792308508' },
    { companyId: 'cmp-3', name: 'Gamma Consulting', nip: '5252248481' },
  ],
};

export const mockCompanyTaxInfo = {
  companyId: 'cmp-1',
  name: 'Przykładowa Firma sp. z o.o.',
  nip: '5260001246',
  taxOfficeCode: '1471',
  taxationForm: 'general_scale',
  sellerStatus: 1,
  vatSettlementPeriod: 'monthly',
  incomeTaxAdvancePeriod: 'monthly',
  vatCashMethod: false,
};

export const mockAiEntries = {
  data: [
    {
      id: 'ai-1',
      sourceDocType: 'cost',
      sourceDocId: 'cost-9001',
      ksefInvoiceId: 'FZ/2025/0044',
      status: 'pending',
      postings: [
        { account: '402-01', description: 'Zużycie energii elektrycznej', debit: 1000.45, credit: 0 },
        { account: '221-01', description: 'VAT naliczony 23%', debit: 230.1, credit: 0 },
        { account: '202-01', description: 'Rozrachunki z dostawcą', debit: 0, credit: 1230.55 },
      ],
      vatCategory: { code: 'K_43', rate: '23' },
      summary: 'Faktura za energię elektryczną — PGE Obrót S.A.',
      anomaly: null,
      model: 'qwen2.5:14b',
      confidence: 0.94,
      bookkeptBy: 'ai',
      source: 'ai',
      createdAt: daysFromNow(-12),
    },
    {
      id: 'ai-2',
      sourceDocType: 'sale',
      sourceDocId: 'sale-5521',
      ksefInvoiceId: 'FV/2025/0210',
      status: 'booked',
      postings: [
        { account: '201-04', description: 'Należność od klienta', debit: 18450, credit: 0 },
        { account: '700-01', description: 'Sprzedaż usług programistycznych', debit: 0, credit: 15000 },
        { account: '222-01', description: 'VAT należny 23%', debit: 0, credit: 3450 },
      ],
      vatCategory: { code: 'K_19', rate: '23' },
      summary: 'Sprzedaż usług programistycznych — Klient Alfa S.A.',
      anomaly: null,
      model: 'qwen2.5:14b',
      confidence: 0.98,
      bookkeptBy: 'ai',
      source: 'ai',
      reviewedBy: 'Ewa Księgowa',
      reviewRating: 5,
      reviewedAt: daysFromNow(-9),
      createdAt: daysFromNow(-10),
    },
    {
      id: 'ai-3',
      sourceDocType: 'cost',
      sourceDocId: 'cost-9042',
      ksefInvoiceId: 'FZ/2025/0051',
      status: 'flagged',
      postings: [
        { account: '401-03', description: 'Zakup paliwa', debit: 2317.07, credit: 0 },
        { account: '221-01', description: 'VAT naliczony 23% (odliczenie 50%)', debit: 266.46, credit: 0 },
        { account: '202-01', description: 'Rozrachunki z dostawcą', debit: 0, credit: 2583.53 },
      ],
      vatCategory: { code: 'K_43', rate: '23' },
      summary: 'Zakup paliwa — PKN Orlen S.A.',
      anomaly: { reason: 'Kwota odbiega o 340% od średniej dla tego dostawcy', severity: 'high' },
      model: 'qwen2.5:14b',
      confidence: 0.57,
      bookkeptBy: 'ai',
      source: 'ai',
      createdAt: daysFromNow(-6),
    },
    {
      id: 'ai-4',
      sourceDocType: 'cost',
      sourceDocId: 'cost-9077',
      status: 'pending',
      postings: [
        { account: '402-05', description: 'Usługi telekomunikacyjne', debit: 289.43, credit: 0 },
        { account: '221-01', description: 'VAT naliczony 23%', debit: 66.57, credit: 0 },
        { account: '202-01', description: 'Rozrachunki z dostawcą', debit: 0, credit: 356 },
      ],
      vatCategory: { code: 'K_43', rate: '23' },
      summary: 'Usługi telekomunikacyjne — Orange Polska S.A.',
      anomaly: { reason: 'Brak numeru KSeF na dokumencie źródłowym', severity: 'low' },
      model: 'qwen2.5:7b',
      confidence: 0.82,
      bookkeptBy: 'ai',
      source: 'ai',
      createdAt: daysFromNow(-4),
    },
    {
      id: 'ai-5',
      sourceDocType: 'sale',
      sourceDocId: 'sale-5544',
      ksefInvoiceId: 'KOR/2025/0007',
      status: 'rejected',
      postings: [
        { account: '700-01', description: 'Korekta sprzedaży', debit: 1200, credit: 0 },
        { account: '201-05', description: 'Rozrachunki z odbiorcą', debit: 0, credit: 1476 },
        { account: '222-01', description: 'Korekta VAT należnego', debit: 276, credit: 0 },
      ],
      vatCategory: { code: 'K_19', rate: '23' },
      summary: 'Faktura korygująca — Beta Handel sp.j.',
      anomaly: null,
      model: 'qwen2.5:14b',
      confidence: 0.61,
      bookkeptBy: 'ai',
      source: 'ai',
      reviewedBy: 'Ewa Księgowa',
      reviewRating: 2,
      reviewComment: 'Błędne konto korekty — zaksięgowano ręcznie.',
      reviewedAt: daysFromNow(-2),
      createdAt: daysFromNow(-3),
    },
    {
      id: 'ai-6',
      sourceDocType: 'cost',
      sourceDocId: 'cost-9099',
      ksefInvoiceId: 'FZ/2025/0063',
      status: 'booked',
      postings: [
        { account: '402-02', description: 'Czynsz najmu biura', debit: 3800, credit: 0 },
        { account: '221-01', description: 'VAT naliczony 23%', debit: 874, credit: 0 },
        { account: '202-01', description: 'Rozrachunki z wynajmującym', debit: 0, credit: 4674 },
      ],
      vatCategory: { code: 'K_43', rate: '23' },
      summary: 'Czynsz najmu biura — Nieruchomości Kowalski sp. z o.o.',
      anomaly: null,
      model: 'qwen2.5:14b',
      confidence: 0.9,
      bookkeptBy: 'ai',
      source: 'ai',
      reviewedBy: 'Ewa Księgowa',
      reviewRating: 4,
      reviewedAt: daysFromNow(-1),
      createdAt: daysFromNow(-2),
    },
    {
      id: 'man-1',
      sourceDocType: 'cost',
      sourceDocId: 'RB/2025/0009',
      source: 'manual',
      counterparty: 'Poczta Polska S.A.',
      documentDate: dateFromNow(-5),
      status: 'booked',
      postings: [
        { account: '403-01', description: 'Usługi pocztowe', debit: 148.78, credit: 0 },
        { account: '202-01', description: 'Rozrachunki z dostawcą', debit: 0, credit: 148.78 },
      ],
      vatCategory: { code: 'K_43' },
      summary: 'Opłaty pocztowe — dokument pominięty przez AI',
      anomaly: null,
      model: '',
      confidence: 0,
      bookkeptBy: 'manual',
      reviewedBy: 'Ewa Księgowa',
      reviewedAt: daysFromNow(-5),
      createdAt: daysFromNow(-5),
    },
    {
      id: 'man-2',
      sourceDocType: 'sale',
      sourceDocId: 'FV/2025/0301',
      source: 'manual',
      counterparty: 'Gamma Consulting sp. z o.o.',
      documentDate: dateFromNow(-3),
      status: 'booked',
      postings: [
        { account: '201-06', description: 'Należność od odbiorcy', debit: 6150, credit: 0 },
        { account: '700-02', description: 'Sprzedaż usług doradczych', debit: 0, credit: 5000 },
        { account: '222-01', description: 'VAT należny 23%', debit: 0, credit: 1150 },
      ],
      vatCategory: { code: 'K_19' },
      summary: 'Sprzedaż usług doradczych — zaksięgowana ręcznie',
      anomaly: null,
      model: '',
      confidence: 0,
      bookkeptBy: 'manual',
      reviewedBy: 'Ewa Księgowa',
      reviewedAt: daysFromNow(-3),
      createdAt: daysFromNow(-3),
    },
  ],
};

export function mockManualEntryCreate(req: { body?: unknown }): { id: string } {
  const body = (req.body ?? {}) as {
    sourceDocType?: string;
    documentRef?: string;
    counterparty?: string;
    documentDate?: string;
    summary?: string;
    vatCategory?: string;
    postings?: Array<{ account: string; description: string; debit: number; credit: number }>;
  };
  const id = 'man-' + Math.random().toString(36).slice(2, 10);
  mockAiEntries.data.unshift({
    id,
    sourceDocType: (body.sourceDocType as 'cost' | 'sale') ?? 'cost',
    sourceDocId: body.documentRef ?? '',
    source: 'manual',
    counterparty: body.counterparty ?? '',
    documentDate: body.documentDate ?? '',
    status: 'booked',
    postings: body.postings ?? [],
    vatCategory: body.vatCategory ? { code: body.vatCategory } : {},
    summary: body.summary ?? '',
    anomaly: null,
    model: '',
    confidence: 0,
    bookkeptBy: 'manual',
    reviewedBy: 'Ewa Księgowa',
    reviewedAt: daysFromNow(0),
    createdAt: daysFromNow(0),
  } as (typeof mockAiEntries.data)[number]);
  return { id };
}

export const mockClientVehicles = {
  data: [
    { id: 'veh-1', name: 'Škoda Octavia', registrationNo: 'GD 12345', vehicleType: 'passenger', vatDeductionPct: 50, costDeductionPct: 75, privateUse: true, status: 'active' },
    { id: 'veh-2', name: 'Ford Transit', registrationNo: 'GD 67890', vehicleType: 'truck', vatDeductionPct: 100, costDeductionPct: 100, privateUse: false, status: 'active' },
    { id: 'veh-3', name: 'Wózek widłowy Linde H25', registrationNo: '—', vehicleType: 'other', vatDeductionPct: 100, costDeductionPct: 100, privateUse: false, status: 'active' },
  ],
};

const vehicleSettlements: Record<string, Array<Record<string, unknown>>> = {
  'veh-1': [
    { id: 'vs-1', vehicleId: 'veh-1', period: monthsAgo(1), vatDeductionPct: 50, costDeductionPct: 75, totalVat: 345, deductibleVat: 172.5, nondeductibleVat: 172.5, totalGross: 1845, deductibleCost: 1254.38, mileageKm: 60, mileageAmount: 46 },
    { id: 'vs-2', vehicleId: 'veh-1', period: monthsAgo(2), vatDeductionPct: 50, costDeductionPct: 75, totalVat: 289, deductibleVat: 144.5, nondeductibleVat: 144.5, totalGross: 1544, deductibleCost: 1050.75, mileageKm: 42, mileageAmount: 32.5 },
  ],
  'veh-2': [
    { id: 'vs-3', vehicleId: 'veh-2', period: monthsAgo(1), vatDeductionPct: 100, costDeductionPct: 100, totalVat: 920, deductibleVat: 920, nondeductibleVat: 0, totalGross: 4920, deductibleCost: 4000, mileageKm: 0, mileageAmount: 0 },
  ],
  'veh-3': [],
};

export function mockVehicleSettlements(vehicleId: string): { data: Array<Record<string, unknown>> } {
  return { data: vehicleSettlements[vehicleId] ?? [] };
}

export const mockFiscalReports = {
  reports: [
    { id: 'fr-1', type: 'daily_Z', report_number: 'RF/2025/06/0031', device_id: 'PL0123456789', period_from: dateFromNow(-2), period_to: dateFromNow(-2), issued_at: epochSecondsFromNow(-2), status: 'imported', booked: false, booked_by: '', booked_at: '' },
    { id: 'fr-2', type: 'daily_Z', report_number: 'RF/2025/06/0030', device_id: 'PL0123456789', period_from: dateFromNow(-3), period_to: dateFromNow(-3), issued_at: epochSecondsFromNow(-3), status: 'imported', booked: false, booked_by: '', booked_at: '' },
    { id: 'fr-3', type: 'monthly', report_number: 'RF/2025/05/M', device_id: 'PL0123456789', period_from: monthsAgo(1) + '-01', period_to: monthsAgo(1) + '-31', issued_at: epochSecondsFromNow(-16), status: 'sent', booked: true, booked_by: 'Ewa Księgowa', booked_at: dateFromNow(-12) },
    { id: 'fr-4', type: 'periodic', report_number: 'RF/2025/Q2', device_id: 'PL0987654321', period_from: monthsAgo(3) + '-01', period_to: monthsAgo(1) + '-30', issued_at: epochSecondsFromNow(-10), status: 'sent', booked: false, booked_by: '', booked_at: '' },
    { id: 'fr-5', type: 'daily_Z', report_number: 'RF/2025/06/0029', device_id: 'PL0987654321', period_from: dateFromNow(-4), period_to: dateFromNow(-4), issued_at: epochSecondsFromNow(-4), status: 'imported', booked: false, booked_by: '', booked_at: '' },
    { id: 'fr-6', type: 'monthly', report_number: 'RF/2025/04/M', device_id: 'PL0987654321', period_from: monthsAgo(2) + '-01', period_to: monthsAgo(2) + '-30', issued_at: epochSecondsFromNow(-46), status: 'sent', booked: true, booked_by: 'Ewa Księgowa', booked_at: dateFromNow(-40) },
  ],
  count: 6,
};

const fiscalReportDetails: Record<string, Record<string, unknown>> = {
  'fr-1': {
    id: 'fr-1', company_id: 'cmp-1', type: 'daily_Z', report_number: 'RF/2025/06/0031', device_id: 'PL0123456789',
    session_id: 'S-8842', period_from: dateFromNow(-2), period_to: dateFromNow(-2), issued_at: epochSecondsFromNow(-2), status: 'imported',
    total_gross: 4287.5, total_net: 3485.77, total_vat: 801.73,
    vat_breakdown: [
      { vat_rate: '23', net: 3120.5, vat: 717.72, gross: 3838.22 },
      { vat_rate: '8', net: 365.27, vat: 29.22, gross: 394.49 },
      { vat_rate: '5', net: 0, vat: 0, gross: 0 },
      { vat_rate: '0', net: 54.79, vat: 0, gross: 54.79 },
    ],
    counters: 'Paragony: 128 | Faktury: 4 | Storna: 1',
  },
  'fr-3': {
    id: 'fr-3', company_id: 'cmp-1', type: 'monthly', report_number: 'RF/2025/05/M', device_id: 'PL0123456789',
    session_id: 'M-2025-05', period_from: monthsAgo(1) + '-01', period_to: monthsAgo(1) + '-31', issued_at: epochSecondsFromNow(-16), status: 'sent',
    total_gross: 96210.4, total_net: 78219.84, total_vat: 17990.56,
    vat_breakdown: [
      { vat_rate: '23', net: 71200, vat: 16376, gross: 87576 },
      { vat_rate: '8', net: 7019.84, vat: 561.59, gross: 7581.43 },
    ],
    counters: 'Paragony: 3241 | Faktury: 58',
  },
};

export function mockFiscalReportById(id: string): Record<string, unknown> {
  const summary = mockFiscalReports.reports.find((r) => r.id === id) ?? mockFiscalReports.reports[0];
  const base =
    fiscalReportDetails[id] ?? {
      ...summary,
      company_id: 'cmp-1',
      total_gross: 0,
      total_net: 0,
      total_vat: 0,
      vat_breakdown: [],
    };
  return { ...base, booked: summary.booked, booked_by: summary.booked_by, booked_at: summary.booked_at };
}

export function mockFiscalReportBook(id: string, req: MinimalRequest): Record<string, unknown> {
  const body = (req.body as Record<string, unknown>) ?? {};
  const booked = body['booked'] !== false;
  return {
    id,
    booked,
    booked_by: booked ? 'Ewa Księgowa' : '',
    booked_at: booked ? dateFromNow(0) : '',
  };
}

export const mockTaxSettlements = {
  data: [
    { taxType: 'VAT', period: monthsAgo(1), amount: 6520.5, currency: 'PLN', note: 'JPK_V7M wysłany', closedBy: 'Ewa Księgowa', closedAt: dateFromNow(-9), paidAt: dateFromNow(-4), paymentRef: 'PRZ/2025/06/118', status: 'paid' },
    { taxType: 'PIT', period: monthsAgo(1), amount: 3380, currency: 'PLN', note: 'Zaliczka PIT-5', closedBy: 'Ewa Księgowa', closedAt: dateFromNow(-7), paidAt: '', paymentRef: '', status: 'closed' },
    { taxType: 'ZUS', period: monthsAgo(1), amount: 1712.35, currency: 'PLN', note: 'DRA złożona', closedBy: 'Ewa Księgowa', closedAt: dateFromNow(-6), paidAt: dateFromNow(-3), paymentRef: 'ZUS/2025/06', status: 'paid' },
    { taxType: 'VAT', period: monthsAgo(0), amount: 7180.9, currency: 'PLN', note: '', closedBy: '', closedAt: '', paidAt: '', paymentRef: '', status: 'open' },
    { taxType: 'CIT', period: monthsAgo(2), amount: 9240, currency: 'PLN', note: 'Zaliczka miesięczna', closedBy: 'Ewa Księgowa', closedAt: dateFromNow(-38), paidAt: '', paymentRef: '', status: 'closed' },
  ],
};

export function mockTaxSettlementClose(req: MinimalRequest): Record<string, unknown> {
  const body = (req.body as Record<string, unknown>) ?? {};
  return {
    taxType: (body['taxType'] as string) ?? 'VAT',
    period: (body['period'] as string) ?? monthsAgo(0),
    amount: Number(body['amount']) || 0,
    currency: (body['currency'] as string) || 'PLN',
    note: (body['note'] as string) ?? '',
    closedBy: 'Ewa Księgowa',
    closedAt: dateFromNow(0),
    paidAt: '',
    paymentRef: '',
    status: 'closed',
  };
}

export function mockTaxSettlementReopen(req: MinimalRequest): Record<string, unknown> {
  const body = (req.body as Record<string, unknown>) ?? {};
  return {
    taxType: (body['taxType'] as string) ?? 'VAT',
    period: (body['period'] as string) ?? monthsAgo(0),
    status: 'open',
  };
}

export function mockTaxSettlementMarkPaid(req: MinimalRequest): Record<string, unknown> {
  const body = (req.body as Record<string, unknown>) ?? {};
  return {
    taxType: (body['taxType'] as string) ?? 'VAT',
    period: (body['period'] as string) ?? monthsAgo(0),
    paymentRef: (body['paymentRef'] as string) ?? '',
    paidAt: dateFromNow(0),
    status: 'paid',
  };
}

export function mockTaxSettlementSuggest(req: MinimalRequest): Record<string, unknown> {
  const taxType = (requestParam(req, 'taxType') ?? 'VAT').toUpperCase();
  const period = requestParam(req, 'period') ?? monthsAgo(0);
  if (taxType === 'VAT') {
    const declaration = mockDeclarations.data.find((d) => d.period === period);
    if (declaration) {
      return { taxType, period, available: true, amount: declaration.data.amountDue, source: 'vat_declaration' };
    }
  }
  return { taxType, period, available: false, amount: 0, source: 'manual' };
}

export const mockDeclarations = {
  data: [
    { id: 'dec-1', period: monthsAgo(1), data: { net: 71200, vat: 16376, amountDue: 16376, notes: 'Sprzedaż krajowa 23%' }, createdAt: daysFromNow(-14), updatedAt: daysFromNow(-9) },
    { id: 'dec-2', period: monthsAgo(2), data: { net: 68400, vat: 15732, amountDue: 14210, notes: 'Odliczenie nadwyżki z poprzedniego okresu' }, createdAt: daysFromNow(-44), updatedAt: daysFromNow(-40) },
    { id: 'dec-3', period: monthsAgo(3), data: { net: 52180, vat: 12001.4, amountDue: 12001.4, notes: '' }, createdAt: daysFromNow(-74), updatedAt: daysFromNow(-70) },
    { id: 'dec-4', period: monthsAgo(0), data: { net: 38940, vat: 8956.2, amountDue: 8956.2, notes: 'Wersja robocza — do zamknięcia okresu' }, createdAt: daysFromNow(-2), updatedAt: daysFromNow(-1) },
  ],
};

interface MockSubmission {
  id: string;
  type: string;
  period: string;
  status: string;
  fileName: string;
  govReference: string;
  errorDetail: string;
  upoAvailable: boolean;
  response: string;
  submittedAt?: string;
  confirmedAt?: string;
  createdAt: string;
  updatedAt: string;
}

export const mockSubmissions: { submitterMode: string; data: MockSubmission[] } = {
  submitterMode: 'stub',
  data: [
    { id: 'sub-1', type: 'JPK_VAT', period: monthsAgo(1), status: 'confirmed', fileName: 'JPK_V7M_2025-05.xml', govReference: '20250625-AB12CD34EF', errorDetail: '', upoAvailable: true, response: 'UPO', submittedAt: daysFromNow(-9), confirmedAt: daysFromNow(-9), createdAt: daysFromNow(-9), updatedAt: daysFromNow(-9) },
    { id: 'sub-2', type: 'VAT_7', period: monthsAgo(1), status: 'sent', fileName: 'VAT7_2025-05.xml', govReference: '20250701-9F3C21AA', errorDetail: '', upoAvailable: false, response: 'Wysłano do bramki e-Deklaracje, oczekiwanie na UPO', submittedAt: daysFromNow(-8), createdAt: daysFromNow(-8), updatedAt: daysFromNow(-8) },
    { id: 'sub-3', type: 'ZUS_DRA', period: monthsAgo(1), status: 'generated', fileName: 'ZUS_DRA_2025-05.xml', govReference: '', errorDetail: '', upoAvailable: false, response: '', createdAt: daysFromNow(-6), updatedAt: daysFromNow(-6) },
    { id: 'sub-4', type: 'JPK_VAT', period: monthsAgo(2), status: 'error', fileName: 'JPK_V7M_2025-04.xml', govReference: '', errorDetail: 'Błąd walidacji: niezgodny NIP nabywcy w pozycji 12 (kod 412)', upoAvailable: false, response: 'Błąd walidacji: niezgodny NIP nabywcy w pozycji 12 (kod 412)', createdAt: daysFromNow(-40), updatedAt: daysFromNow(-39) },
    { id: 'sub-5', type: 'VAT_7', period: monthsAgo(0), status: 'queued', fileName: '', govReference: '', errorDetail: '', upoAvailable: false, response: '', createdAt: daysFromNow(-1), updatedAt: daysFromNow(-1) },
  ],
};

function findSubmission(id: string): MockSubmission | undefined {
  return mockSubmissions.data.find((s) => s.id === id);
}

export function mockSubmissionSend(id: string): Record<string, unknown> {
  const sub = findSubmission(id);
  const reference = 'STUB-' + Math.random().toString(36).slice(2, 10).toUpperCase();
  if (sub) {
    sub.status = 'sent';
    sub.govReference = reference;
    sub.errorDetail = '';
    sub.response = 'Wysłano do bramki e-Deklaracje, oczekiwanie na UPO';
    sub.submittedAt = daysFromNow(0);
    sub.updatedAt = daysFromNow(0);
  }
  return { id, status: 'sent', response: 'Wysłano do bramki e-Deklaracje, oczekiwanie na UPO', govReference: reference };
}

export function mockSubmissionRefresh(id: string): Record<string, unknown> {
  const sub = findSubmission(id);
  if (sub && (sub.status === 'sent' || sub.status === 'queued')) {
    sub.status = 'confirmed';
    sub.upoAvailable = true;
    sub.response = 'UPO';
    sub.confirmedAt = daysFromNow(0);
    sub.updatedAt = daysFromNow(0);
    return { id, status: 'confirmed', govReference: sub.govReference, upoAvailable: true };
  }
  return { id, status: sub ? sub.status : 'sent', govReference: sub ? sub.govReference : '' };
}

export const mockVatRegisters = {
  data: [
    { id: 'reg-sale', data: { name: 'Rejestr sprzedaży', type: 'sales' }, createdAt: daysFromNow(-120) },
    { id: 'reg-purchase', data: { name: 'Rejestr zakupów', type: 'purchase' }, createdAt: daysFromNow(-120) },
  ],
};

const vatRecordsByRegister: Record<string, Array<Record<string, unknown>>> = {
  'reg-sale': [
    { id: 'vr-1', registerId: 'reg-sale', invoiceId: 'inv-1', data: { date: dateFromNow(-22), documentNumber: 'FV/2025/0001', description: 'Usługi programistyczne — Klient Alfa S.A.', net: 15000, vat: 3450, rate: '23' }, createdAt: daysFromNow(-22) },
    { id: 'vr-2', registerId: 'reg-sale', invoiceId: 'inv-2', data: { date: dateFromNow(-18), documentNumber: 'FV/2025/0002', description: 'Licencja SaaS — Beta Handel sp.j.', net: 4200, vat: 966, rate: '23' }, createdAt: daysFromNow(-18) },
    { id: 'vr-3', registerId: 'reg-sale', invoiceId: 'inv-3', data: { date: dateFromNow(-12), documentNumber: 'FV/2025/0003', description: 'Materiały szkoleniowe (książki)', net: 1800, vat: 90, rate: '5' }, createdAt: daysFromNow(-12) },
    { id: 'vr-4', registerId: 'reg-sale', invoiceId: 'inv-4', data: { date: dateFromNow(-6), documentNumber: 'FV/2025/0004', description: 'Eksport usług — kontrahent UE', net: 9600, vat: 0, rate: '0' }, createdAt: daysFromNow(-6) },
  ],
  'reg-purchase': [
    { id: 'vr-5', registerId: 'reg-purchase', invoiceId: 'cost-9001', data: { date: dateFromNow(-20), documentNumber: 'FZ/2025/0044', description: 'Energia elektryczna — PGE Obrót S.A.', net: 1000.45, vat: 230.1, rate: '23' }, createdAt: daysFromNow(-20) },
    { id: 'vr-6', registerId: 'reg-purchase', invoiceId: 'cost-9099', data: { date: dateFromNow(-15), documentNumber: 'FZ/2025/0063', description: 'Czynsz najmu biura', net: 3800, vat: 874, rate: '23' }, createdAt: daysFromNow(-15) },
    { id: 'vr-7', registerId: 'reg-purchase', invoiceId: 'cost-9077', data: { date: dateFromNow(-8), documentNumber: 'FZ/2025/0058', description: 'Usługi telekomunikacyjne — Orange Polska', net: 289.43, vat: 66.57, rate: '23' }, createdAt: daysFromNow(-8) },
  ],
};

export const mockVatRecords = {
  data: [...vatRecordsByRegister['reg-sale'], ...vatRecordsByRegister['reg-purchase']],
};

export function mockVatRecordsFor(registerId: string): { data: Array<Record<string, unknown>> } {
  return { data: vatRecordsByRegister[registerId] ?? [] };
}

export const mockComarchConnectors = {
  data: [
    { connectorId: 'con-1', name: 'Optima — Przykładowa Firma', status: 'active', lastSeenAt: daysFromNow(0), createdAt: daysFromNow(-90) },
    { connectorId: 'con-2', name: 'Optima — stacja księgowej', status: 'active', lastSeenAt: daysFromNow(-2), createdAt: daysFromNow(-60) },
    { connectorId: 'con-3', name: 'Optima — laptop archiwalny', status: 'revoked', lastSeenAt: daysFromNow(-30), createdAt: daysFromNow(-200) },
  ],
};

export const mockComarchExports = {
  data: [
    { jobId: 'exp-1', companyId: 'cmp-1', kind: 'sales_invoice', refId: 'FV/2025/0004', period: monthsAgo(1), status: 'done', optimaRef: 'OPT-SI-88421', attempts: 1, queuedAt: daysFromNow(-2), pickedAt: daysFromNow(-2), completedAt: daysFromNow(-2), connectorName: 'Optima — Przykładowa Firma' },
    { jobId: 'exp-2', companyId: 'cmp-1', kind: 'cost_invoice', refId: 'FZ/2025/0063', period: monthsAgo(1), status: 'done', optimaRef: 'OPT-CI-88422', attempts: 1, queuedAt: daysFromNow(-2), pickedAt: daysFromNow(-2), completedAt: daysFromNow(-2), connectorName: 'Optima — Przykładowa Firma' },
    { jobId: 'exp-3', companyId: 'cmp-1', kind: 'contractor', refId: 'KH-0231', status: 'in_progress', attempts: 1, queuedAt: daysFromNow(-1), pickedAt: daysFromNow(-1), connectorName: 'Optima — stacja księgowej' },
    { jobId: 'exp-4', companyId: 'cmp-1', kind: 'sales_invoice', refId: 'FV/2025/0003', period: monthsAgo(1), status: 'queued', attempts: 0, queuedAt: daysFromNow(0) },
    { jobId: 'exp-5', companyId: 'cmp-1', kind: 'cost_invoice', refId: 'FZ/2025/0058', period: monthsAgo(1), status: 'error', errorMessage: 'Konektor offline — przekroczono limit czasu dzierżawy', attempts: 3, queuedAt: daysFromNow(-1), pickedAt: daysFromNow(-1), connectorName: 'Optima — stacja księgowej' },
    { jobId: 'exp-6', companyId: 'cmp-1', kind: 'contractor', refId: 'KH-0198', status: 'cancelled', attempts: 0, queuedAt: daysFromNow(-3) },
    { jobId: 'exp-7', companyId: 'cmp-1', kind: 'sales_invoice', refId: 'FV/2025/0002', period: monthsAgo(2), status: 'done', optimaRef: 'OPT-SI-88400', attempts: 2, queuedAt: daysFromNow(-40), pickedAt: daysFromNow(-40), completedAt: daysFromNow(-40), connectorName: 'Optima — Przykładowa Firma' },
  ],
};

export const mockThreads = {
  data: [
    { id: 'thr-1', subject: 'Dokumenty do VAT-7 za maj', lastMessage: 'Proszę o dosłanie wyciągu bankowego za czerwiec.', lastMessageAt: daysFromNow(-1), unreadCount: 2, updatedAt: daysFromNow(-1) },
    { id: 'thr-2', subject: 'Faktura korygująca — Beta Handel', lastMessage: 'Dziękuję, korekta została zaksięgowana.', lastMessageAt: daysFromNow(-3), unreadCount: 0, updatedAt: daysFromNow(-3) },
    { id: 'thr-3', subject: 'Rozliczenie samochodu służbowego', lastMessage: 'Czy kilometrówka za czerwiec jest już gotowa?', lastMessageAt: daysFromNow(-5), unreadCount: 1, updatedAt: daysFromNow(-5) },
    { id: 'thr-4', subject: 'Zaliczka PIT za maj', lastMessage: 'W załączeniu potwierdzenie przelewu do US.', lastMessageAt: daysFromNow(-8), unreadCount: 0, updatedAt: daysFromNow(-8) },
  ],
};

const threadDetails: Record<string, Record<string, unknown>> = {
  'thr-1': {
    id: 'thr-1',
    subject: 'Dokumenty do VAT-7 za maj',
    messages: [
      { id: 'm-1', authorType: 'accountant', authorId: 'acc-1', body: 'Dzień dobry, przygotowuję deklarację VAT-7 za maj. Brakuje mi wyciągu bankowego za czerwiec.', createdAt: daysFromNow(-2), mine: true },
      { id: 'm-2', authorType: 'client', authorId: 'cli-1', body: 'Dzień dobry, prześlę wyciąg jeszcze dziś po południu.', createdAt: daysFromNow(-1), mine: false },
      { id: 'm-3', authorType: 'client', authorId: 'cli-1', body: 'Proszę o dosłanie wyciągu bankowego za czerwiec.', createdAt: daysFromNow(-1), mine: false },
    ],
  },
  'thr-2': {
    id: 'thr-2',
    subject: 'Faktura korygująca — Beta Handel',
    messages: [
      { id: 'm-4', authorType: 'client', authorId: 'cli-1', body: 'Wystawiliśmy korektę do faktury FV/2025/0210. W załączeniu.', createdAt: daysFromNow(-4), mine: false },
      { id: 'm-5', authorType: 'accountant', authorId: 'acc-1', body: 'Dziękuję, korekta została zaksięgowana.', createdAt: daysFromNow(-3), mine: true },
    ],
  },
  'thr-3': {
    id: 'thr-3',
    subject: 'Rozliczenie samochodu służbowego',
    messages: [
      { id: 'm-6', authorType: 'client', authorId: 'cli-1', body: 'Czy kilometrówka za czerwiec jest już gotowa?', createdAt: daysFromNow(-5), mine: false },
    ],
  },
  'thr-4': {
    id: 'thr-4',
    subject: 'Zaliczka PIT za maj',
    messages: [
      { id: 'm-7', authorType: 'accountant', authorId: 'acc-1', body: 'Zaliczka PIT za maj wynosi 3 380 zł, termin do 20. dnia miesiąca.', createdAt: daysFromNow(-9), mine: true },
      { id: 'm-8', authorType: 'client', authorId: 'cli-1', body: 'W załączeniu potwierdzenie przelewu do US.', createdAt: daysFromNow(-8), mine: false },
    ],
  },
};

export function mockThreadById(id: string): Record<string, unknown> {
  return threadDetails[id] ?? { id, subject: '', messages: [] };
}

export const mockSupportTickets = {
  data: [
    { id: 'tic-1', subject: 'Eksport JPK do Comarch kończy się błędem', category: 'technical', status: 'open', lastMessage: 'Konektor zgłasza timeout przy większych paczkach.', lastMessageAt: daysFromNow(-1), unreadCount: 1, createdAt: daysFromNow(-3), updatedAt: daysFromNow(-1) },
    { id: 'tic-2', subject: 'Jak dodać nowego kontrahenta?', category: 'question', status: 'resolved', lastMessage: 'Dziękuję, już działa.', lastMessageAt: daysFromNow(-6), unreadCount: 0, createdAt: daysFromNow(-8), updatedAt: daysFromNow(-6) },
    { id: 'tic-3', subject: 'Prośba o zwiększenie limitu faktur', category: 'billing', status: 'waiting', lastMessage: 'Czekamy na akceptację działu handlowego.', lastMessageAt: daysFromNow(-2), unreadCount: 0, createdAt: daysFromNow(-4), updatedAt: daysFromNow(-2) },
    { id: 'tic-4', subject: 'Błąd 500 przy generowaniu PDF', category: 'technical', status: 'in_progress', lastMessage: 'Przekazaliśmy zgłoszenie do zespołu technicznego.', lastMessageAt: daysFromNow(-1), unreadCount: 2, createdAt: daysFromNow(-2), updatedAt: daysFromNow(-1) },
    { id: 'tic-5', subject: 'Rezygnacja z modułu Kadry', category: 'billing', status: 'closed', lastMessage: 'Zgłoszenie zamknięte.', lastMessageAt: daysFromNow(-20), unreadCount: 0, createdAt: daysFromNow(-25), updatedAt: daysFromNow(-20) },
  ],
};

const supportTicketDetails: Record<string, Record<string, unknown>> = {
  'tic-1': {
    id: 'tic-1', subject: 'Eksport JPK do Comarch kończy się błędem', category: 'technical', status: 'open',
    messages: [
      { id: 'sm-1', authorType: 'user', authorId: 'u-1', authorName: 'Ewa Księgowa', body: 'Przy eksporcie faktur do Optimy pojawia się timeout dla paczek powyżej 200 dokumentów.', createdAt: daysFromNow(-3), mine: true },
      { id: 'sm-2', authorType: 'support', authorId: 's-1', authorName: 'Wsparcie Księgowskaz', body: 'Dzień dobry, prosimy o numer konektora i przybliżoną godzinę wystąpienia błędu.', createdAt: daysFromNow(-2), mine: false },
      { id: 'sm-3', authorType: 'user', authorId: 'u-1', authorName: 'Ewa Księgowa', body: 'Konektor zgłasza timeout przy większych paczkach.', createdAt: daysFromNow(-1), mine: true },
    ],
  },
  'tic-4': {
    id: 'tic-4', subject: 'Błąd 500 przy generowaniu PDF', category: 'technical', status: 'in_progress',
    messages: [
      { id: 'sm-4', authorType: 'user', authorId: 'u-1', authorName: 'Ewa Księgowa', body: 'Generowanie PDF faktury FV/2025/0004 kończy się błędem 500.', createdAt: daysFromNow(-2), mine: true },
      { id: 'sm-5', authorType: 'support', authorId: 's-1', authorName: 'Wsparcie Księgowskaz', body: 'Przekazaliśmy zgłoszenie do zespołu technicznego.', createdAt: daysFromNow(-1), mine: false },
    ],
  },
};

export function mockSupportTicketById(id: string): Record<string, unknown> {
  return (
    supportTicketDetails[id] ?? {
      ...(mockSupportTickets.data.find((t) => t.id === id) ?? { id, subject: '', status: 'open' }),
      messages: [],
    }
  );
}

// ---------------------------------------------------------------------------
// Śledzenie czasu (time tracking) — stanowy mock w pamięci.
// Utrzymuje uruchomiony timer i historię wpisów przez czas trwania sesji demo.
// ---------------------------------------------------------------------------

export type MockTimeCategory = 'bookkeeping' | 'vat' | 'payroll' | 'consultation' | 'other';

export interface MockTimeEntry {
  id: string;
  accountantId: string;
  companyId: string;
  companyName?: string;
  startedAt: string;
  stoppedAt: string | null;
  durationSeconds: number;
  description: string;
  category: MockTimeCategory;
  billable: boolean;
  source: 'web' | 'desktop';
  clientUuid?: string;
  createdAt: string;
  updatedAt: string;
}

interface MinimalRequest {
  url: string;
  body?: unknown;
  headers?: { get(name: string): string | null };
  params?: { get(name: string): string | null };
}

const MOCK_ACCOUNTANT_ID = 'accountant-1';

function companyNameFor(companyId: string): string {
  return mockAssignedCompanies.data.find((c) => c.companyId === companyId)?.name ?? companyId;
}

function minutesAgoIso(minutes: number): string {
  return new Date(Date.now() - minutes * 60_000).toISOString();
}

function newTimeId(): string {
  return 'tt-' + Math.random().toString(36).slice(2, 10);
}

function seedEntry(
  companyId: string,
  startMinutesAgo: number,
  durationSeconds: number,
  category: MockTimeCategory,
  description: string,
  billable: boolean,
): MockTimeEntry {
  const startedAt = minutesAgoIso(startMinutesAgo);
  const stoppedAt = new Date(Date.parse(startedAt) + durationSeconds * 1000).toISOString();
  return {
    id: newTimeId(),
    accountantId: MOCK_ACCOUNTANT_ID,
    companyId,
    companyName: companyNameFor(companyId),
    startedAt,
    stoppedAt,
    durationSeconds,
    description,
    category,
    billable,
    source: 'web',
    createdAt: startedAt,
    updatedAt: stoppedAt,
  };
}

interface TimeTrackingState {
  running: MockTimeEntry | null;
  entries: MockTimeEntry[];
}

const timeTracking: TimeTrackingState = {
  running: null,
  entries: [
    seedEntry('cmp-1', 60 * 24 * 1, 5400, 'bookkeeping', 'Księgowanie faktur kosztowych', true),
    seedEntry('cmp-1', 60 * 24 * 2, 2700, 'vat', 'Przygotowanie JPK_V7M', true),
    seedEntry('cmp-2', 60 * 24 * 2 + 120, 3600, 'payroll', 'Lista płac — czerwiec', true),
    seedEntry('cmp-2', 60 * 24 * 4, 1800, 'consultation', 'Konsultacja telefoniczna', false),
    seedEntry('cmp-3', 60 * 24 * 3, 4500, 'bookkeeping', 'Uzgodnienie sald', true),
    seedEntry('cmp-3', 60 * 24 * 6, 1200, 'other', 'Porządkowanie dokumentów', false),
  ],
};

function requestBody(req: MinimalRequest): Record<string, unknown> {
  return (req.body as Record<string, unknown>) ?? {};
}

function requestCompanyId(req: MinimalRequest): string {
  return req.headers?.get('company-id') ?? 'cmp-1';
}

function requestParam(req: MinimalRequest, key: string): string | null {
  return req.params?.get(key) ?? null;
}

function runningSnapshot(): MockTimeEntry | null {
  const current = timeTracking.running;
  if (!current) return null;
  const durationSeconds = Math.max(0, Math.floor((Date.now() - Date.parse(current.startedAt)) / 1000));
  return { ...current, durationSeconds };
}

function finalizeRunning(description?: string): MockTimeEntry | null {
  const current = timeTracking.running;
  if (!current) return null;
  const stoppedAt = new Date().toISOString();
  const durationSeconds = Math.max(0, Math.floor((Date.parse(stoppedAt) - Date.parse(current.startedAt)) / 1000));
  const finalized: MockTimeEntry = {
    ...current,
    stoppedAt,
    durationSeconds,
    description: description?.trim() ? description : current.description,
    updatedAt: stoppedAt,
  };
  timeTracking.entries = [finalized, ...timeTracking.entries];
  timeTracking.running = null;
  return finalized;
}

export function mockTimerCurrent(): { entry: MockTimeEntry | null } {
  return { entry: runningSnapshot() };
}

export function mockTimerStart(req: MinimalRequest): { entry: MockTimeEntry } {
  // Backend zatrzymuje poprzedni timer, gdy startuje nowy — odwzorowujemy to.
  finalizeRunning();
  const body = requestBody(req);
  const companyId = requestCompanyId(req);
  const now = new Date().toISOString();
  const entry: MockTimeEntry = {
    id: newTimeId(),
    accountantId: MOCK_ACCOUNTANT_ID,
    companyId,
    companyName: companyNameFor(companyId),
    startedAt: now,
    stoppedAt: null,
    durationSeconds: 0,
    description: typeof body['description'] === 'string' ? (body['description'] as string) : '',
    category: (body['category'] as MockTimeCategory) ?? 'bookkeeping',
    billable: body['billable'] !== false,
    source: 'web',
    createdAt: now,
    updatedAt: now,
  };
  timeTracking.running = entry;
  return { entry };
}

export function mockTimerStop(req: MinimalRequest): { entry: MockTimeEntry | null } {
  const body = requestBody(req);
  const description = typeof body['description'] === 'string' ? (body['description'] as string) : undefined;
  return { entry: finalizeRunning(description) };
}

function upperBound(to: string): number {
  return to.length === 10 ? Date.parse(`${to}T23:59:59.999Z`) : Date.parse(to);
}

export function mockTimeEntriesList(req: MinimalRequest): { data: MockTimeEntry[] } {
  const from = requestParam(req, 'from');
  const to = requestParam(req, 'to');
  const companyId = requestParam(req, 'companyId');
  const data = timeTracking.entries.filter((e) => {
    if (companyId && e.companyId !== companyId) return false;
    const started = Date.parse(e.startedAt);
    if (from && started < Date.parse(from)) return false;
    if (to && started > upperBound(to)) return false;
    return true;
  });
  return { data };
}

export function mockTimeEntryCreate(req: MinimalRequest): { entry: MockTimeEntry } {
  const body = requestBody(req);
  const companyId = (body['companyId'] as string) || requestCompanyId(req);
  const startedAt = (body['startedAt'] as string) || new Date().toISOString();
  const stoppedAt = (body['stoppedAt'] as string) || new Date().toISOString();
  const durationSeconds = Math.max(0, Math.floor((Date.parse(stoppedAt) - Date.parse(startedAt)) / 1000));
  const now = new Date().toISOString();
  const entry: MockTimeEntry = {
    id: newTimeId(),
    accountantId: MOCK_ACCOUNTANT_ID,
    companyId,
    companyName: companyNameFor(companyId),
    startedAt,
    stoppedAt,
    durationSeconds,
    description: typeof body['description'] === 'string' ? (body['description'] as string) : '',
    category: (body['category'] as MockTimeCategory) ?? 'bookkeeping',
    billable: body['billable'] !== false,
    source: 'web',
    createdAt: now,
    updatedAt: now,
  };
  timeTracking.entries = [entry, ...timeTracking.entries];
  return { entry };
}

export function mockTimeEntryUpdate(
  match: RegExpMatchArray,
  req: MinimalRequest,
): { entry: MockTimeEntry | null } {
  const id = match[1];
  const idx = timeTracking.entries.findIndex((e) => e.id === id);
  if (idx < 0) return { entry: null };
  const body = requestBody(req);
  const existing = timeTracking.entries[idx];
  const startedAt = (body['startedAt'] as string) || existing.startedAt;
  const stoppedAt =
    body['stoppedAt'] !== undefined ? (body['stoppedAt'] as string | null) : existing.stoppedAt;
  const durationSeconds = stoppedAt
    ? Math.max(0, Math.floor((Date.parse(stoppedAt) - Date.parse(startedAt)) / 1000))
    : existing.durationSeconds;
  const updated: MockTimeEntry = {
    ...existing,
    startedAt,
    stoppedAt,
    durationSeconds,
    description: typeof body['description'] === 'string' ? (body['description'] as string) : existing.description,
    category: (body['category'] as MockTimeCategory) ?? existing.category,
    billable: typeof body['billable'] === 'boolean' ? (body['billable'] as boolean) : existing.billable,
    updatedAt: new Date().toISOString(),
  };
  timeTracking.entries[idx] = updated;
  return { entry: updated };
}

export function mockTimeEntryDelete(match: RegExpMatchArray): Record<string, never> {
  const id = match[1];
  timeTracking.entries = timeTracking.entries.filter((e) => e.id !== id);
  return {};
}

interface MockSummaryGroup {
  key: string;
  label: string;
  seconds: number;
  billableSeconds: number;
}

export function mockTimeReportSummary(req: MinimalRequest): {
  totalSeconds: number;
  billableSeconds: number;
  byGroup: MockSummaryGroup[];
} {
  const from = requestParam(req, 'from');
  const to = requestParam(req, 'to');
  const groupBy = (requestParam(req, 'groupBy') as 'company' | 'day' | 'category' | null) ?? 'company';
  const entries = timeTracking.entries.filter((e) => {
    const started = Date.parse(e.startedAt);
    if (from && started < Date.parse(from)) return false;
    if (to && started > upperBound(to)) return false;
    return true;
  });

  let totalSeconds = 0;
  let billableSeconds = 0;
  const groups = new Map<string, MockSummaryGroup>();

  for (const e of entries) {
    totalSeconds += e.durationSeconds;
    if (e.billable) billableSeconds += e.durationSeconds;

    const key =
      groupBy === 'day' ? e.startedAt.slice(0, 10) : groupBy === 'category' ? e.category : e.companyId;
    const label =
      groupBy === 'day' ? key : groupBy === 'category' ? e.category : companyNameFor(e.companyId);

    const group = groups.get(key) ?? { key, label, seconds: 0, billableSeconds: 0 };
    group.seconds += e.durationSeconds;
    if (e.billable) group.billableSeconds += e.durationSeconds;
    groups.set(key, group);
  }

  return {
    totalSeconds,
    billableSeconds,
    byGroup: [...groups.values()].sort((a, b) => b.seconds - a.seconds),
  };
}

interface MockInvoiceDraftLine {
  description: string;
  quantityHours: number;
  unitPrice: number;
  amount: number;
  category: MockTimeCategory;
}

const CATEGORY_LABEL_PL: Record<MockTimeCategory, string> = {
  bookkeeping: 'Księgowanie',
  vat: 'VAT',
  payroll: 'Płace',
  consultation: 'Konsultacja',
  other: 'Inne',
};

function round2(value: number): number {
  return Math.round(value * 100) / 100;
}

/** Zaokrągla liczbę godzin w górę do pełnego kwadransa (0,25 h). */
function ceilToQuarter(hours: number): number {
  return Math.ceil(hours * 4 - 1e-9) / 4;
}

/**
 * Generuje szkic pozycji faktury z rozliczalnych wpisów czasu: grupuje po
 * kategorii, przelicza sekundy na godziny (opcjonalnie do kwadransa) i mnoży
 * przez stawkę godzinową.
 */
export function mockInvoiceDraft(req: MinimalRequest): {
  lines: MockInvoiceDraftLine[];
  totalAmount: number;
  totalSeconds: number;
} {
  const body = requestBody(req);
  const companyId = (body['companyId'] as string) || requestCompanyId(req);
  const from = typeof body['from'] === 'string' ? (body['from'] as string) : null;
  const to = typeof body['to'] === 'string' ? (body['to'] as string) : null;
  const categoryFilter = (body['category'] as MockTimeCategory) || null;
  const hourlyRate = Number(body['hourlyRate']) || 0;
  const roundToQuarter = body['roundToQuarter'] === true;

  const entries = timeTracking.entries.filter((e) => {
    if (!e.billable) return false;
    if (e.companyId !== companyId) return false;
    if (categoryFilter && e.category !== categoryFilter) return false;
    const started = Date.parse(e.startedAt);
    if (from && started < Date.parse(from)) return false;
    if (to && started > upperBound(to)) return false;
    return true;
  });

  const secondsByCategory = new Map<MockTimeCategory, number>();
  let totalSeconds = 0;
  for (const e of entries) {
    totalSeconds += e.durationSeconds;
    secondsByCategory.set(e.category, (secondsByCategory.get(e.category) ?? 0) + e.durationSeconds);
  }

  const lines: MockInvoiceDraftLine[] = [];
  let totalAmount = 0;
  for (const [category, seconds] of secondsByCategory) {
    const rawHours = seconds / 3600;
    const quantityHours = round2(roundToQuarter ? ceilToQuarter(rawHours) : rawHours);
    const amount = round2(quantityHours * hourlyRate);
    totalAmount += amount;
    lines.push({
      description: `Usługi księgowe — ${CATEGORY_LABEL_PL[category]}`,
      quantityHours,
      unitPrice: hourlyRate,
      amount,
      category,
    });
  }
  lines.sort((a, b) => b.amount - a.amount);

  return { lines, totalAmount: round2(totalAmount), totalSeconds };
}

// ---------------------------------------------------------------------------
// Środki trwałe (fixed assets) — dane demonstracyjne dla panelu księgowego.
// ---------------------------------------------------------------------------

export const mockFixedAssetRecords = [
  {
    id: 'fa-1',
    inventoryNo: 'ST/2025/001',
    name: 'Laptop Dell XPS 15',
    kstCode: '491',
    acquisitionDate: '2025-01-10',
    acceptanceDate: '2025-01-15',
    otDocumentNo: 'OT/2025/001',
    initialValue: 12000,
    method: 'linear',
    annualRatePct: 30,
    coefficient: 1,
    oneTimeBasis: '',
    deductibleCap: null,
    subsidyPct: 0,
    location: 'Biuro Gdańsk',
    responsiblePerson: 'Anna Kowalska',
    acquisitionDocRef: '',
    status: 'in_use',
    currentBasis: 12000,
    accumulated: 300,
    netValue: 11700,
    notes: '',
  },
  {
    id: 'fa-2',
    inventoryNo: 'ST/2025/002',
    name: 'Samochód osobowy Toyota Corolla',
    kstCode: '741',
    acquisitionDate: '2025-02-01',
    acceptanceDate: '2025-02-05',
    otDocumentNo: 'OT/2025/002',
    initialValue: 180000,
    method: 'linear',
    annualRatePct: 20,
    coefficient: 1,
    oneTimeBasis: '',
    deductibleCap: 150000,
    subsidyPct: 0,
    location: 'Flota',
    responsiblePerson: 'Jan Nowak',
    acquisitionDocRef: '',
    status: 'in_use',
    currentBasis: 180000,
    accumulated: 0,
    netValue: 180000,
    notes: 'Limit KUP 150 000 zł (auto osobowe).',
  },
  {
    id: 'fa-3',
    inventoryNo: 'ST/2025/003',
    name: 'Drukarka etykiet Zebra ZD421',
    kstCode: '803',
    acquisitionDate: '2025-03-12',
    acceptanceDate: '2025-03-12',
    otDocumentNo: 'OT/2025/003',
    initialValue: 3200,
    method: 'one_time',
    annualRatePct: 100,
    coefficient: 1,
    oneTimeBasis: 'low_value',
    deductibleCap: null,
    subsidyPct: 0,
    location: 'Magazyn',
    responsiblePerson: 'Katarzyna Wiśniewska',
    acquisitionDocRef: '',
    status: 'fully_depreciated',
    currentBasis: 3200,
    accumulated: 3200,
    netValue: 0,
    notes: 'Odpis jednorazowy — niskocenny składnik majątku.',
  },
  {
    id: 'fa-4',
    inventoryNo: 'ST/2025/004',
    name: 'Linia produkcyjna CNC',
    kstCode: '410',
    acquisitionDate: '2024-11-05',
    acceptanceDate: '2024-11-20',
    otDocumentNo: 'OT/2024/018',
    initialValue: 420000,
    method: 'declining',
    annualRatePct: 14,
    coefficient: 2,
    oneTimeBasis: '',
    deductibleCap: null,
    subsidyPct: 15,
    location: 'Hala produkcyjna',
    responsiblePerson: 'Marek Zieliński',
    acquisitionDocRef: 'DOF/2024/007',
    status: 'in_use',
    currentBasis: 420000,
    accumulated: 98000,
    netValue: 322000,
    notes: 'Amortyzacja degresywna (współczynnik 2,0); dotacja 15%.',
  },
  {
    id: 'fa-5',
    inventoryNo: 'ST/2023/011',
    name: 'Grunt inwestycyjny — działka 112/4',
    kstCode: '030',
    acquisitionDate: '2023-06-01',
    acceptanceDate: '2023-06-01',
    otDocumentNo: 'OT/2023/011',
    initialValue: 250000,
    method: 'none',
    annualRatePct: 0,
    coefficient: 1,
    oneTimeBasis: '',
    deductibleCap: null,
    subsidyPct: 0,
    location: 'Gdańsk, ul. Portowa',
    responsiblePerson: 'Jan Nowak',
    acquisitionDocRef: '',
    status: 'sold',
    currentBasis: 250000,
    accumulated: 0,
    netValue: 250000,
    notes: 'Grunt niepodlegający amortyzacji; sprzedany w 2025 r.',
  },
];

export const mockFixedAssets = { data: mockFixedAssetRecords };

export function mockFixedAssetById(id: string) {
  return mockFixedAssetRecords.find((a) => a.id === id) ?? mockFixedAssetRecords[0];
}

const fixedAssetDisposals: Record<string, Record<string, unknown>> = {
  'fa-5': {
    id: 'disp-1',
    assetId: 'fa-5',
    disposalDate: '2025-05-18',
    disposalType: 'sale',
    documentNo: 'LT/2025/002',
    amount: 310000,
    netValueAtDisposal: 250000,
    notes: 'Sprzedaż gruntu; zysk ze zbycia 60 000 zł.',
    createdAt: '2025-05-18',
  },
};

export function mockFixedAssetDisposalFor(id: string): { disposal: Record<string, unknown> | null } {
  return { disposal: fixedAssetDisposals[id] ?? null };
}

export const mockFixedAssetPlan = {
  data: [
    { period: '2025-02', odpis: 300, kup: 300, nkup: 0, accumulated: 300, netValue: 11700 },
    { period: '2025-03', odpis: 300, kup: 300, nkup: 0, accumulated: 600, netValue: 11400 },
    { period: '2025-04', odpis: 300, kup: 300, nkup: 0, accumulated: 900, netValue: 11100 },
  ],
};

export const mockFixedAssetImprovements = { data: [] as unknown[] };

export const mockFixedAssetDepreciations = {
  data: [
    {
      id: 'dep-1',
      assetId: 'fa-1',
      period: '2025-02',
      amount: 300,
      kupAmount: 300,
      nkupAmount: 0,
      accumulated: 300,
      netValue: 11700,
      posted: true,
    },
  ],
};

export function mockKeycloakToken(): Record<string, unknown> {
  const header = btoa(JSON.stringify({ alg: 'none', typ: 'JWT' }));
  const payload = btoa(
    JSON.stringify({
      sub: 'accountant-1',
      email: 'ksiegowa@biuro-rachunkowe.pl',
      preferred_username: 'ksiegowa@biuro-rachunkowe.pl',
      given_name: 'Ewa',
      realm_access: { roles: ['accountant'] },
      exp: Math.floor(Date.now() / 1000) + 3600,
    }),
  );
  return {
    access_token: `${header}.${payload}.mock-signature`,
    refresh_token: 'mock-refresh-token',
    token_type: 'Bearer',
    expires_in: 1800,
    refresh_expires_in: 3600,
    scope: 'openid',
  };
}

interface MockChartAccount {
  accountNumber: string;
  name: string;
  team: number;
  normalSide: 'debit' | 'credit';
  parentNumber?: string;
  isPostable: boolean;
  isActive: boolean;
  source: string;
  hasPostings: boolean;
}

export const mockChartAccounts: { data: MockChartAccount[] } = {
  data: [
    { accountNumber: '010', name: 'Środki trwałe', team: 0, normalSide: 'debit', isPostable: true, isActive: true, source: 'template', hasPostings: true },
    { accountNumber: '070', name: 'Umorzenie środków trwałych', team: 0, normalSide: 'credit', isPostable: true, isActive: true, source: 'template', hasPostings: false },
    { accountNumber: '100', name: 'Kasa', team: 1, normalSide: 'debit', isPostable: true, isActive: true, source: 'template', hasPostings: true },
    { accountNumber: '130', name: 'Rachunek bieżący', team: 1, normalSide: 'debit', isPostable: true, isActive: true, source: 'template', hasPostings: true },
    { accountNumber: '200', name: 'Rozrachunki z odbiorcami', team: 2, normalSide: 'debit', isPostable: false, isActive: true, source: 'template', hasPostings: false },
    { accountNumber: '200-1', name: 'Odbiorcy krajowi — Auto-Complex Sp. z o.o.', team: 2, normalSide: 'debit', parentNumber: '200', isPostable: true, isActive: true, source: 'manual', hasPostings: true },
    { accountNumber: '200-2', name: 'Odbiorcy krajowi — Piekarnia Złoty Kłos', team: 2, normalSide: 'debit', parentNumber: '200', isPostable: true, isActive: true, source: 'manual', hasPostings: false },
    { accountNumber: '201', name: 'Rozrachunki z dostawcami', team: 2, normalSide: 'credit', isPostable: true, isActive: true, source: 'template', hasPostings: true },
    { accountNumber: '221', name: 'Rozrachunki z tytułu VAT', team: 2, normalSide: 'credit', isPostable: true, isActive: true, source: 'template', hasPostings: true },
    { accountNumber: '330', name: 'Towary', team: 3, normalSide: 'debit', isPostable: true, isActive: true, source: 'template', hasPostings: false },
    { accountNumber: '402', name: 'Usługi obce', team: 4, normalSide: 'debit', isPostable: true, isActive: true, source: 'template', hasPostings: true },
    { accountNumber: '404', name: 'Wynagrodzenia', team: 4, normalSide: 'debit', isPostable: true, isActive: true, source: 'template', hasPostings: false },
    { accountNumber: '406', name: 'Amortyzacja', team: 4, normalSide: 'debit', isPostable: true, isActive: false, source: 'template', hasPostings: false },
    { accountNumber: '501', name: 'Koszty działalności podstawowej', team: 5, normalSide: 'debit', isPostable: true, isActive: true, source: 'template', hasPostings: false },
    { accountNumber: '640', name: 'Rozliczenia międzyokresowe kosztów', team: 6, normalSide: 'debit', isPostable: true, isActive: true, source: 'template', hasPostings: false },
    { accountNumber: '700', name: 'Przychody ze sprzedaży produktów', team: 7, normalSide: 'credit', isPostable: true, isActive: true, source: 'template', hasPostings: true },
    { accountNumber: '730', name: 'Przychody ze sprzedaży towarów', team: 7, normalSide: 'credit', isPostable: true, isActive: true, source: 'template', hasPostings: false },
    { accountNumber: '800', name: 'Kapitał (fundusz) podstawowy', team: 8, normalSide: 'credit', isPostable: true, isActive: true, source: 'template', hasPostings: false },
    { accountNumber: '860', name: 'Wynik finansowy', team: 8, normalSide: 'credit', isPostable: true, isActive: true, source: 'template', hasPostings: false },
  ],
};

export const mockAccountingSettings: {
  companyId: string;
  accountingMode: 'kpir' | 'full';
  fiscalYearStart: number;
} = {
  companyId: 'cmp-1',
  accountingMode: 'full',
  fiscalYearStart: 1,
};

function teamOfNumber(accountNumber: string): number {
  const first = accountNumber.trim().charAt(0);
  const digit = Number(first);
  return Number.isNaN(digit) ? 0 : digit;
}

export function mockChartAccountCreate(req: MinimalRequest): MockChartAccount {
  const body = (req.body as Record<string, unknown>) ?? {};
  const accountNumber = ((body['accountNumber'] as string) ?? '').trim();
  const parentNumber = ((body['parentNumber'] as string) ?? '').trim();
  const parent = mockChartAccounts.data.find((a) => a.accountNumber === parentNumber);
  const normalSide =
    (body['normalSide'] as 'debit' | 'credit') || parent?.normalSide || 'debit';
  const account: MockChartAccount = {
    accountNumber,
    name: ((body['name'] as string) ?? '').trim(),
    team: teamOfNumber(accountNumber),
    normalSide,
    parentNumber: parentNumber || undefined,
    isPostable: body['isPostable'] !== false,
    isActive: true,
    source: 'manual',
    hasPostings: false,
  };
  mockChartAccounts.data.push(account);
  return account;
}

export function mockChartAccountUpdate(
  match: RegExpMatchArray,
  req: MinimalRequest,
): MockChartAccount {
  const number = decodeURIComponent(match[1]);
  const body = (req.body as Record<string, unknown>) ?? {};
  const account = mockChartAccounts.data.find((a) => a.accountNumber === number);
  if (!account) {
    return {
      accountNumber: number,
      name: '',
      team: teamOfNumber(number),
      normalSide: 'debit',
      isPostable: true,
      isActive: true,
      source: 'manual',
      hasPostings: false,
    };
  }
  if (typeof body['name'] === 'string') {
    account.name = (body['name'] as string).trim();
  }
  if (typeof body['isActive'] === 'boolean') {
    account.isActive = body['isActive'] as boolean;
  }
  return account;
}

export function mockAccountingSettingsUpdate(req: MinimalRequest): typeof mockAccountingSettings {
  const body = (req.body as Record<string, unknown>) ?? {};
  const mode = body['accountingMode'];
  if (mode === 'kpir' || mode === 'full') {
    mockAccountingSettings.accountingMode = mode;
  }
  const start = Number(body['fiscalYearStart']);
  if (start >= 1 && start <= 12) {
    mockAccountingSettings.fiscalYearStart = start;
  }
  return mockAccountingSettings;
}

type JournalEntrySource =
  | 'ai_entry'
  | 'manual'
  | 'direct'
  | 'storno'
  | 'depreciation'
  | 'vat'
  | 'payroll';
type JournalEntryStatus = 'draft' | 'posted' | 'reversed';

interface MockJournalPosting {
  accountNumber: string;
  description?: string;
  debit: number;
  credit: number;
}

interface MockJournalEntry {
  id: string;
  entryNo: number;
  entryDate: string;
  period: string;
  description: string;
  documentRef?: string;
  sourceRefType: JournalEntrySource;
  sourceRefId?: string;
  status: JournalEntryStatus;
  reversedBy?: string;
  postedBy: string;
  postedAt: string;
  createdAt: string;
  postings: MockJournalPosting[];
}

export const mockJournalEntries: { data: MockJournalEntry[] } = {
  data: [
    {
      id: 'je-2026-07-001',
      entryNo: 1,
      entryDate: '2026-07-02',
      period: '2026-07',
      description: 'Podjęcie gotówki z rachunku do kasy',
      documentRef: 'KP 07/2026',
      sourceRefType: 'direct',
      status: 'posted',
      postedBy: 'Anna Księgowa',
      postedAt: '2026-07-02T09:12:00Z',
      createdAt: '2026-07-02T09:12:00Z',
      postings: [
        { accountNumber: '100', description: 'Kasa', debit: 5000, credit: 0 },
        { accountNumber: '130', description: 'Rachunek bieżący', debit: 0, credit: 5000 },
      ],
    },
    {
      id: 'je-2026-07-002',
      entryNo: 2,
      entryDate: '2026-07-08',
      period: '2026-07',
      description: 'Faktura sprzedaży — Auto-Complex Sp. z o.o.',
      documentRef: 'FV/2026/07/12',
      sourceRefType: 'ai_entry',
      sourceRefId: 'ai-8842',
      status: 'posted',
      postedBy: 'Asystent AI',
      postedAt: '2026-07-08T11:40:00Z',
      createdAt: '2026-07-08T11:40:00Z',
      postings: [
        { accountNumber: '200-1', description: 'Należność brutto', debit: 12300, credit: 0 },
        { accountNumber: '730', description: 'Sprzedaż towarów netto', debit: 0, credit: 10000 },
        { accountNumber: '221', description: 'VAT należny 23%', debit: 0, credit: 2300 },
      ],
    },
    {
      id: 'je-2026-07-003',
      entryNo: 3,
      entryDate: '2026-07-14',
      period: '2026-07',
      description: 'Faktura kosztowa — usługi księgowe',
      documentRef: 'FZ/128/2026',
      sourceRefType: 'manual',
      status: 'posted',
      postedBy: 'Anna Księgowa',
      postedAt: '2026-07-14T15:05:00Z',
      createdAt: '2026-07-14T15:05:00Z',
      postings: [
        { accountNumber: '402', description: 'Usługi obce netto', debit: 1626.02, credit: 0 },
        { accountNumber: '221', description: 'VAT naliczony 23%', debit: 373.98, credit: 0 },
        { accountNumber: '201', description: 'Zobowiązanie wobec dostawcy', debit: 0, credit: 2000 },
      ],
    },
    {
      id: 'je-2026-07-004',
      entryNo: 4,
      entryDate: '2026-07-16',
      period: '2026-07',
      description: 'Błędne ujęcie kosztu materiałów',
      documentRef: 'FZ/131/2026',
      sourceRefType: 'direct',
      status: 'reversed',
      reversedBy: 'je-2026-07-005',
      postedBy: 'Anna Księgowa',
      postedAt: '2026-07-16T10:20:00Z',
      createdAt: '2026-07-16T10:20:00Z',
      postings: [
        { accountNumber: '402', description: 'Usługi obce', debit: 500, credit: 0 },
        { accountNumber: '201', description: 'Zobowiązanie', debit: 0, credit: 500 },
      ],
    },
    {
      id: 'je-2026-07-005',
      entryNo: 5,
      entryDate: '2026-07-16',
      period: '2026-07',
      description: 'STORNO: Błędne ujęcie kosztu materiałów',
      documentRef: 'FZ/131/2026',
      sourceRefType: 'storno',
      sourceRefId: 'je-2026-07-004',
      status: 'posted',
      postedBy: 'Anna Księgowa',
      postedAt: '2026-07-16T10:24:00Z',
      createdAt: '2026-07-16T10:24:00Z',
      postings: [
        { accountNumber: '402', description: 'Usługi obce', debit: 0, credit: 500 },
        { accountNumber: '201', description: 'Zobowiązanie', debit: 500, credit: 0 },
      ],
    },
  ],
};

function nextJournalEntryNo(): number {
  return mockJournalEntries.data.reduce((max, e) => Math.max(max, e.entryNo), 0) + 1;
}

export function mockJournalEntriesFor(req: MinimalRequest): { data: MockJournalEntry[] } {
  const period = req.params?.get('period') ?? '';
  if (!period) {
    return { data: mockJournalEntries.data };
  }
  return { data: mockJournalEntries.data.filter((e) => e.period === period) };
}

export function mockJournalEntryCreate(req: MinimalRequest): MockJournalEntry {
  const body = (req.body as Record<string, unknown>) ?? {};
  const entryDate = ((body['entryDate'] as string) ?? '2026-07-01').trim();
  const period = ((body['period'] as string) ?? '').trim() || entryDate.slice(0, 7);
  if (!periodPostingAllowed(period)) {
    throw new MockHttpError(409, {
      message: 'accounting period is closed or locked and cannot be posted to',
    });
  }
  const rawPostings = Array.isArray(body['postings'])
    ? (body['postings'] as Array<Record<string, unknown>>)
    : [];
  const postings: MockJournalPosting[] = rawPostings.map((p) => ({
    accountNumber: String(p['accountNumber'] ?? '').trim(),
    description: p['description'] ? String(p['description']) : undefined,
    debit: Number(p['debit']) || 0,
    credit: Number(p['credit']) || 0,
  }));
  const entryNo = nextJournalEntryNo();
  const now = `${entryDate}T12:00:00Z`;
  const entry: MockJournalEntry = {
    id: `je-manual-${entryNo}`,
    entryNo,
    entryDate,
    period,
    description: String(body['description'] ?? '').trim(),
    documentRef: body['documentRef'] ? String(body['documentRef']).trim() : undefined,
    sourceRefType: 'direct',
    status: 'posted',
    postedBy: 'Anna Księgowa',
    postedAt: now,
    createdAt: now,
    postings,
  };
  mockJournalEntries.data.push(entry);
  return entry;
}

export function mockJournalEntryReverse(match: RegExpMatchArray): MockJournalEntry {
  const id = decodeURIComponent(match[1]);
  const original = mockJournalEntries.data.find((e) => e.id === id);
  if (original && !periodPostingAllowed(original.period)) {
    throw new MockHttpError(409, {
      message: 'accounting period is closed or locked and cannot be posted to',
    });
  }
  const entryNo = nextJournalEntryNo();
  const stornoId = `je-storno-${entryNo}`;
  if (original) {
    original.status = 'reversed';
    original.reversedBy = stornoId;
  }
  const now = `${original?.entryDate ?? '2026-07-16'}T12:30:00Z`;
  const storno: MockJournalEntry = {
    id: stornoId,
    entryNo,
    entryDate: original?.entryDate ?? '2026-07-16',
    period: original?.period ?? '2026-07',
    description: `STORNO: ${original?.description ?? ''}`,
    documentRef: original?.documentRef,
    sourceRefType: 'storno',
    sourceRefId: id,
    status: 'posted',
    postedBy: 'Anna Księgowa',
    postedAt: now,
    createdAt: now,
    postings: (original?.postings ?? []).map((p) => ({
      accountNumber: p.accountNumber,
      description: p.description,
      debit: p.credit,
      credit: p.debit,
    })),
  };
  mockJournalEntries.data.push(storno);
  return storno;
}

export function mockGeneralLedger(req: MinimalRequest): {
  period: string;
  accounts: Array<{
    accountNumber: string;
    name: string;
    debitTurnover: number;
    creditTurnover: number;
    balance: number;
    balanceSide: 'debit' | 'credit' | '';
  }>;
  totalDebit: number;
  totalCredit: number;
  balanced: boolean;
} {
  const period = req.params?.get('period') ?? '';
  const names = new Map(mockChartAccounts.data.map((a) => [a.accountNumber, a.name]));
  const buckets = new Map<string, { debit: number; credit: number }>();
  for (const entry of mockJournalEntries.data) {
    if (entry.status === 'draft') continue;
    if (period && entry.period !== period) continue;
    for (const p of entry.postings) {
      const bucket = buckets.get(p.accountNumber) ?? { debit: 0, credit: 0 };
      bucket.debit += p.debit;
      bucket.credit += p.credit;
      buckets.set(p.accountNumber, bucket);
    }
  }
  const accounts = [...buckets.entries()]
    .sort(([a], [b]) => a.localeCompare(b))
    .map(([accountNumber, b]) => {
      const balance = Math.round((b.debit - b.credit) * 100) / 100;
      const balanceSide: 'debit' | 'credit' | '' =
        balance > 0.005 ? 'debit' : balance < -0.005 ? 'credit' : '';
      return {
        accountNumber,
        name: names.get(accountNumber) ?? accountNumber,
        debitTurnover: Math.round(b.debit * 100) / 100,
        creditTurnover: Math.round(b.credit * 100) / 100,
        balance,
        balanceSide,
      };
    });
  const totalDebit = Math.round(accounts.reduce((s, a) => s + a.debitTurnover, 0) * 100) / 100;
  const totalCredit = Math.round(accounts.reduce((s, a) => s + a.creditTurnover, 0) * 100) / 100;
  return {
    period,
    accounts,
    totalDebit,
    totalCredit,
    balanced: Math.abs(totalDebit - totalCredit) < 0.005,
  };
}

interface MockKpirSource {
  entryNo: number;
  entryDate: string;
  period: string;
  documentRef: string;
  counterparty: string;
  description: string;
  col7?: number;
  col8?: number;
  col10?: number;
  col11?: number;
  col12?: number;
  col13?: number;
  col16?: number;
}

export const mockKpirEntries: MockKpirSource[] = [
  { entryNo: 50, entryDate: '2026-06-28', period: '2026-06', documentRef: 'FS/2026/06/50', counterparty: 'Auto-Complex Sp. z o.o.', description: 'Sprzedaż towarów handlowych', col7: 12000 },
  { entryNo: 33, entryDate: '2026-06-15', period: '2026-06', documentRef: 'FZ/2026/06/33', counterparty: 'Hurtownia Stal-Bud', description: 'Zakup towarów handlowych', col10: 5000 },
  { entryNo: 61, entryDate: '2026-07-04', period: '2026-07', documentRef: 'FS/2026/07/12', counterparty: 'Auto-Complex Sp. z o.o.', description: 'Sprzedaż towarów handlowych', col7: 18000 },
  { entryNo: 62, entryDate: '2026-07-09', period: '2026-07', documentRef: 'FS/2026/07/13', counterparty: 'Piekarnia Złoty Kłos', description: 'Sprzedaż usług serwisowych', col7: 6500 },
  { entryNo: 63, entryDate: '2026-07-11', period: '2026-07', documentRef: 'FZ/2026/07/40', counterparty: 'Hurtownia Stal-Bud', description: 'Zakup towarów handlowych wg cen zakupu', col10: 9200 },
  { entryNo: 64, entryDate: '2026-07-11', period: '2026-07', documentRef: 'FZ/2026/07/41', counterparty: 'Trans-Kol Sp. j.', description: 'Transport zakupionych towarów', col11: 480 },
  { entryNo: 65, entryDate: '2026-07-15', period: '2026-07', documentRef: 'NB/2026/07', counterparty: 'Bank Pekao S.A.', description: 'Odsetki od środków na rachunku', col8: 320.5 },
  { entryNo: 66, entryDate: '2026-07-18', period: '2026-07', documentRef: 'FZ/2026/07/42', counterparty: 'Biuro Rachunkowe Debet', description: 'Usługi księgowe za lipiec', col13: 1500 },
  { entryNo: 67, entryDate: '2026-07-20', period: '2026-07', documentRef: 'FZ/2026/07/43', counterparty: 'TechLab Sp. z o.o.', description: 'Prace badawczo-rozwojowe nad aplikacją', col16: 2600 },
  { entryNo: 68, entryDate: '2026-07-31', period: '2026-07', documentRef: 'LP/2026/07', counterparty: 'Lista płac — lipiec', description: 'Wynagrodzenia w gotówce', col12: 7400 },
];

interface MockKpirTotals {
  col7: number;
  col8: number;
  col9: number;
  col10: number;
  col11: number;
  col12: number;
  col13: number;
  col14: number;
  col16: number;
}

function emptyKpirTotals(): MockKpirTotals {
  return { col7: 0, col8: 0, col9: 0, col10: 0, col11: 0, col12: 0, col13: 0, col14: 0, col16: 0 };
}

function accumulateKpir(totals: MockKpirTotals, src: MockKpirSource): void {
  totals.col7 += src.col7 ?? 0;
  totals.col8 += src.col8 ?? 0;
  totals.col10 += src.col10 ?? 0;
  totals.col11 += src.col11 ?? 0;
  totals.col12 += src.col12 ?? 0;
  totals.col13 += src.col13 ?? 0;
  totals.col16 += src.col16 ?? 0;
}

function finalizeKpir(totals: MockKpirTotals): MockKpirTotals {
  const round = (v: number) => Math.round(v * 100) / 100;
  const c7 = round(totals.col7);
  const c8 = round(totals.col8);
  const c12 = round(totals.col12);
  const c13 = round(totals.col13);
  return {
    col7: c7,
    col8: c8,
    col9: round(c7 + c8),
    col10: round(totals.col10),
    col11: round(totals.col11),
    col12: c12,
    col13: c13,
    col14: round(c12 + c13),
    col16: round(totals.col16),
  };
}

export function mockKpir(req: MinimalRequest): {
  year: string;
  period: string;
  rows: Array<
    MockKpirTotals & {
      lp: number;
      entryId: string;
      entryNo: number;
      entryDate: string;
      period: string;
      documentRef: string;
      counterparty: string;
      description: string;
    }
  >;
  totals: MockKpirTotals;
  running: MockKpirTotals;
} {
  const year = req.params?.get('year') ?? '2026';
  const period = req.params?.get('period') ?? '';

  const inYear = mockKpirEntries
    .filter((e) => !year || e.period.startsWith(year))
    .sort((a, b) => a.entryNo - b.entryNo);

  const totalsAcc = emptyKpirTotals();
  const runningAcc = emptyKpirTotals();
  let lp = 0;
  const rows = [] as ReturnType<typeof mockKpir>['rows'];

  for (const src of inYear) {
    const inRunning = !period || src.period <= period;
    const inPeriod = !period || src.period === period;
    if (inRunning) {
      accumulateKpir(runningAcc, src);
    }
    if (inPeriod) {
      accumulateKpir(totalsAcc, src);
      const one = finalizeKpir(finalizeSingle(src));
      lp += 1;
      rows.push({
        lp,
        entryId: `kpir-${src.entryNo}`,
        entryNo: src.entryNo,
        entryDate: src.entryDate,
        period: src.period,
        documentRef: src.documentRef,
        counterparty: src.counterparty,
        description: src.description,
        ...one,
      });
    }
  }

  return {
    year,
    period,
    rows,
    totals: finalizeKpir(totalsAcc),
    running: finalizeKpir(runningAcc),
  };
}

function finalizeSingle(src: MockKpirSource): MockKpirTotals {
  const one = emptyKpirTotals();
  accumulateKpir(one, src);
  return one;
}

// ---------------------------------------------------------------------------
// RZiS (rachunek zysków i strat) + Bilans. Figury dobrane tak, aby wynik
// finansowy netto RZiS zasilał kapitał własny bilansu, a Σ aktywa = Σ pasywa.
// ---------------------------------------------------------------------------

interface MockReportLine {
  code: string;
  label: string;
  amount: number;
}

interface MockReportSection {
  code: string;
  label: string;
  side: 'assets' | 'liabilities';
  lines: MockReportLine[];
  subtotal: number;
}

function reportSection(
  code: string,
  side: 'assets' | 'liabilities',
  lines: MockReportLine[],
): MockReportSection {
  const subtotal = Math.round(lines.reduce((s, l) => s + l.amount, 0) * 100) / 100;
  return { code, label: code, side, lines, subtotal };
}

export const mockIncomeStatementSections: MockReportSection[] = [
  reportSection('A', 'assets', [
    { code: 'A1', label: 'Przychody ze sprzedaży produktów', amount: 185000 },
    { code: 'A2', label: 'Przychody ze sprzedaży towarów i materiałów', amount: 240000 },
  ]),
  reportSection('B', 'liabilities', [
    { code: 'B1', label: 'Amortyzacja', amount: 28000 },
    { code: 'B2', label: 'Zużycie materiałów i energii', amount: 64000 },
    { code: 'B3', label: 'Usługi obce', amount: 52000 },
    { code: 'B4', label: 'Podatki i opłaty', amount: 9000 },
    { code: 'B5', label: 'Wynagrodzenia', amount: 120000 },
    { code: 'B6', label: 'Ubezpieczenia społeczne i inne świadczenia', amount: 24000 },
    { code: 'B7', label: 'Pozostałe koszty rodzajowe', amount: 7000 },
    { code: 'B8', label: 'Wartość sprzedanych towarów i materiałów', amount: 45000 },
    { code: 'B9', label: 'Koszty zarządu', amount: 18000 },
  ]),
  reportSection('D', 'assets', [
    { code: 'D1', label: 'Pozostałe przychody operacyjne', amount: 6000 },
  ]),
  reportSection('E', 'liabilities', [
    { code: 'E1', label: 'Pozostałe koszty operacyjne', amount: 3500 },
  ]),
  reportSection('G', 'assets', [
    { code: 'G1', label: 'Przychody finansowe', amount: 2200 },
  ]),
  reportSection('H', 'liabilities', [
    { code: 'H1', label: 'Koszty finansowe', amount: 4700 },
  ]),
];

function incomeStatementNetResult(): number {
  let result = 0;
  for (const section of mockIncomeStatementSections) {
    result += section.side === 'assets' ? section.subtotal : -section.subtotal;
  }
  return Math.round(result * 100) / 100;
}

export function mockIncomeStatement(req: MinimalRequest): {
  period: string;
  sections: MockReportSection[];
  grossResult: number;
  tax: number;
  netResult: number;
} {
  const period = req.params?.get('period') ?? '';
  const gross = incomeStatementNetResult();
  return {
    period,
    sections: mockIncomeStatementSections,
    grossResult: gross,
    tax: 0,
    netResult: gross,
  };
}

export const mockBalanceSheetAssets: MockReportSection[] = [
  reportSection('AT', 'assets', [
    { code: 'ATI', label: 'Wartości niematerialne i prawne', amount: 15000 },
    { code: 'ATII', label: 'Rzeczowe aktywa trwałe', amount: 320000 },
  ]),
  reportSection('AO', 'assets', [
    { code: 'AOI', label: 'Zapasy', amount: 84000 },
    { code: 'AOII', label: 'Należności krótkoterminowe', amount: 148000 },
    { code: 'AOIII', label: 'Środki pieniężne', amount: 96000 },
    { code: 'AOIV', label: 'Krótkoterminowe rozliczenia międzyokresowe', amount: 12000 },
  ]),
];

export function mockBalanceSheet(req: MinimalRequest): {
  asOf: string;
  period: string;
  assets: MockReportSection[];
  liabilities: MockReportSection[];
  totalAssets: number;
  totalLiabilities: number;
  netResult: number;
  balanced: boolean;
} {
  const asOf = req.params?.get('asOf') ?? '';
  const period = req.params?.get('period') ?? '';
  const netResult = incomeStatementNetResult();

  const liabilities: MockReportSection[] = [
    reportSection('KW', 'liabilities', [
      { code: 'KWI', label: 'Kapitał (fundusz) podstawowy', amount: 300000 },
      { code: 'KWII', label: 'Wynik finansowy z lat ubiegłych', amount: 90000 },
      { code: 'KWWYNIK', label: 'Wynik finansowy netto (zysk/strata)', amount: netResult },
    ]),
    reportSection('ZR', 'liabilities', [
      { code: 'ZRI', label: 'Zobowiązania z tytułu dostaw i usług', amount: 132000 },
      { code: 'ZRII', label: 'Rozrachunki publicznoprawne', amount: 61000 },
      { code: 'ZRIII', label: 'Rozrachunki z pracownikami', amount: 24000 },
      { code: 'ZRIV', label: 'Pozostałe zobowiązania', amount: 10000 },
    ]),
  ];

  const totalAssets =
    Math.round(mockBalanceSheetAssets.reduce((s, x) => s + x.subtotal, 0) * 100) / 100;
  const totalLiabilities =
    Math.round(liabilities.reduce((s, x) => s + x.subtotal, 0) * 100) / 100;

  return {
    asOf,
    period,
    assets: mockBalanceSheetAssets,
    liabilities,
    totalAssets,
    totalLiabilities,
    netResult,
    balanced: Math.abs(totalAssets - totalLiabilities) < 0.005,
  };
}

interface MockOpeningBalanceRow {
  accountNumber: string;
  debit: number;
  credit: number;
}

const mockOpeningBalancesStore: Record<number, MockOpeningBalanceRow[]> = {
  [new Date().getFullYear()]: [
    { accountNumber: '010', debit: 320000, credit: 0 },
    { accountNumber: '130', debit: 96000, credit: 0 },
    { accountNumber: '200-1', debit: 148000, credit: 0 },
    { accountNumber: '201', debit: 0, credit: 132000 },
    { accountNumber: '221', debit: 0, credit: 61000 },
    { accountNumber: '800', debit: 0, credit: 300000 },
    { accountNumber: '860', debit: 0, credit: 71000 },
  ],
};

function openingBalancesTotals(rows: MockOpeningBalanceRow[]): {
  totalDebit: number;
  totalCredit: number;
  balanced: boolean;
} {
  const totalDebit = Math.round(rows.reduce((s, r) => s + (r.debit || 0), 0) * 100) / 100;
  const totalCredit = Math.round(rows.reduce((s, r) => s + (r.credit || 0), 0) * 100) / 100;
  return { totalDebit, totalCredit, balanced: Math.abs(totalDebit - totalCredit) < 0.005 };
}

export function mockOpeningBalances(req: MinimalRequest): {
  fiscalYear: number;
  rows: MockOpeningBalanceRow[];
  totalDebit: number;
  totalCredit: number;
  balanced: boolean;
} {
  const year = Number(req.params?.get('year')) || new Date().getFullYear();
  const rows = mockOpeningBalancesStore[year] ?? [];
  return { fiscalYear: year, rows, ...openingBalancesTotals(rows) };
}

export function mockOpeningBalancesSave(req: MinimalRequest): {
  fiscalYear: number;
  rows: MockOpeningBalanceRow[];
  totalDebit: number;
  totalCredit: number;
  balanced: boolean;
} {
  const body = (req.body as Record<string, unknown>) ?? {};
  const year = Number(body['fiscalYear']) || new Date().getFullYear();
  const incoming = Array.isArray(body['rows']) ? (body['rows'] as MockOpeningBalanceRow[]) : [];
  const rows = incoming
    .map((r) => ({
      accountNumber: String(r.accountNumber ?? '').trim(),
      debit: Math.round((Number(r.debit) || 0) * 100) / 100,
      credit: Math.round((Number(r.credit) || 0) * 100) / 100,
    }))
    .filter((r) => r.accountNumber && (r.debit !== 0 || r.credit !== 0));
  const totals = openingBalancesTotals(rows);
  if (!totals.balanced) {
    throw new MockHttpError(400, {
      message: 'postings not balanced (sum of debits must equal sum of credits)',
    });
  }
  mockOpeningBalancesStore[year] = rows;
  return { fiscalYear: year, rows, ...totals };
}

// ---------------------------------------------------------------------------
// Okresy księgowe (period lock) — stanowy mock w pamięci. Zamknięcie/otwarcie
// zmienia stan współdzielony z księgowaniem: zapis lub storno w zamkniętym
// (lub zablokowanym) okresie zwraca 409, dzięki czemu blokada jest demonstrowalna.
// ---------------------------------------------------------------------------

export class MockHttpError extends Error {
  constructor(
    readonly status: number,
    readonly body: { message: string },
  ) {
    super(body.message);
    this.name = 'MockHttpError';
  }
}

type LedgerPeriodStatus = 'open' | 'closed' | 'locked';

interface MockAccountingPeriod {
  period: string;
  fiscalYear: number;
  status: LedgerPeriodStatus;
  lockedBy: string;
}

function mockCurrentYear(): number {
  return new Date().getFullYear();
}

const ledgerPeriodState = new Map<string, { status: LedgerPeriodStatus; lockedBy: string }>();

(function seedLedgerPeriods(): void {
  const y = mockCurrentYear();
  ledgerPeriodState.set(`${y}-01`, { status: 'closed', lockedBy: 'Anna Księgowa' });
  ledgerPeriodState.set(`${y}-02`, { status: 'closed', lockedBy: 'Anna Księgowa' });
  ledgerPeriodState.set(`${y}-03`, { status: 'locked', lockedBy: 'Anna Księgowa' });
})();

function periodStatusOf(period: string): LedgerPeriodStatus {
  return ledgerPeriodState.get(period)?.status ?? 'open';
}

function periodPostingAllowed(period: string): boolean {
  return periodStatusOf(period) === 'open';
}

export function mockLedgerPeriods(req: MinimalRequest): {
  year: number;
  data: MockAccountingPeriod[];
} {
  const year = Number(req.params?.get('year')) || mockCurrentYear();
  const data: MockAccountingPeriod[] = [];
  for (let month = 1; month <= 12; month++) {
    const period = `${year}-${String(month).padStart(2, '0')}`;
    const entry = ledgerPeriodState.get(period);
    data.push({
      period,
      fiscalYear: year,
      status: entry?.status ?? 'open',
      lockedBy: entry?.lockedBy ?? '',
    });
  }
  return { year, data };
}

export function mockPeriodClose(match: RegExpMatchArray): {
  period: string;
  status: LedgerPeriodStatus;
  warnings: string[];
} {
  const period = decodeURIComponent(match[1]);
  ledgerPeriodState.set(period, { status: 'closed', lockedBy: 'Anna Księgowa' });
  const warnings: string[] = [];
  if (mockTaxSettlements.data.some((s) => s.period === period && s.status === 'open')) {
    warnings.push('open_tax_settlement');
  }
  return { period, status: 'closed', warnings };
}

export function mockPeriodReopen(match: RegExpMatchArray): {
  period: string;
  status: LedgerPeriodStatus;
  warnings: string[];
} {
  const period = decodeURIComponent(match[1]);
  if (periodStatusOf(period) === 'locked') {
    throw new MockHttpError(409, {
      message: 'only closed periods can be reopened; locked periods are hard-locked',
    });
  }
  ledgerPeriodState.set(period, { status: 'open', lockedBy: '' });
  return { period, status: 'open', warnings: [] };
}

type AutoPostSource = 'depreciation' | 'vat' | 'payroll';

interface MockAutoPostResult {
  source: AutoPostSource;
  period: string;
  posted: number;
  skipped: number;
  blocked: number;
  reasons: string[];
  entries: MockJournalEntry[];
}

const autoPostedRefs = new Set<string>();

function lastDayOf(period: string): string {
  const [y, m] = period.split('-').map((n) => Number(n));
  if (!y || !m) return `${period}-28`;
  const day = new Date(y, m, 0).getDate();
  return `${period}-${String(day).padStart(2, '0')}`;
}

function ensureAutoPostPeriodOpen(period: string, source: AutoPostSource): void {
  if (!periodPostingAllowed(period)) {
    throw new MockHttpError(409, {
      message: 'accounting period is closed or locked and cannot be posted to',
    });
  }
  void source;
}

function materializeAutoEntry(
  period: string,
  source: AutoPostSource,
  sourceRefId: string,
  description: string,
  documentRef: string,
  postings: MockJournalPosting[],
  result: MockAutoPostResult,
): void {
  const key = `${source}|${sourceRefId}`;
  if (autoPostedRefs.has(key)) {
    result.skipped++;
    return;
  }
  autoPostedRefs.add(key);
  const entryNo = nextJournalEntryNo();
  const date = lastDayOf(period);
  const now = `${date}T12:00:00Z`;
  const entry: MockJournalEntry = {
    id: `je-${source}-${sourceRefId}`,
    entryNo,
    entryDate: date,
    period,
    description,
    documentRef,
    sourceRefType: source,
    sourceRefId,
    status: 'posted',
    postedBy: 'Anna Księgowa',
    postedAt: now,
    createdAt: now,
    postings,
  };
  mockJournalEntries.data.push(entry);
  result.entries.push(entry);
  result.posted++;
}

export function mockPostDepreciation(req: MinimalRequest): MockAutoPostResult {
  const period = req.params?.get('period') ?? '';
  ensureAutoPostPeriodOpen(period, 'depreciation');
  const result: MockAutoPostResult = {
    source: 'depreciation',
    period,
    posted: 0,
    skipped: 0,
    blocked: 0,
    reasons: [],
    entries: [],
  };
  const rows = [
    { assetId: 'ST/2025/001', name: 'Laptop Dell XPS 15', amount: 333.33 },
    { assetId: 'ST/2024/014', name: 'Wózek widłowy Linde', amount: 1250.0 },
  ];
  for (const row of rows) {
    materializeAutoEntry(
      period,
      'depreciation',
      `${row.assetId}|${period}`,
      `Odpis amortyzacyjny ${period} — ${row.name}`,
      `AM/${period}`,
      [
        { accountNumber: '408', description: 'Amortyzacja (koszt)', debit: row.amount, credit: 0 },
        { accountNumber: '070', description: 'Umorzenie środków trwałych', debit: 0, credit: row.amount },
      ],
      result,
    );
  }
  return result;
}

export function mockPostVat(req: MinimalRequest): MockAutoPostResult {
  const period = req.params?.get('period') ?? '';
  ensureAutoPostPeriodOpen(period, 'vat');
  const body = (req.body as Record<string, unknown>) ?? {};
  const output = Number(body['outputVat']) || 8421.55;
  const input = Number(body['inputVat']) || 3187.4;
  const result: MockAutoPostResult = {
    source: 'vat',
    period,
    posted: 0,
    skipped: 0,
    blocked: 0,
    reasons: [],
    entries: [],
  };
  const net = Math.round((output - input) * 100) / 100;
  const postings: MockJournalPosting[] = [
    { accountNumber: '222', description: 'Zamknięcie VAT należnego', debit: output, credit: 0 },
    { accountNumber: '221', description: 'Zamknięcie VAT naliczonego', debit: 0, credit: input },
  ];
  if (net >= 0) {
    postings.push({ accountNumber: '225', description: 'Zobowiązanie wobec US z tytułu VAT', debit: 0, credit: net });
  } else {
    postings.push({ accountNumber: '225', description: 'Nadwyżka VAT naliczonego', debit: -net, credit: 0 });
  }
  materializeAutoEntry(period, 'vat', period, `Rozliczenie VAT ${period}`, `VAT/${period}`, postings, result);
  return result;
}

export interface MockPayrollAggregate {
  period: string;
  available: boolean;
  gross: number;
  employerContributions: number;
  employeeSocial: number;
  pit: number;
  net: number;
  computedAt: string;
}

function shiftPeriod(offsetMonths: number): string {
  const now = new Date();
  const d = new Date(now.getFullYear(), now.getMonth() + offsetMonths, 1);
  const year = d.getFullYear();
  const month = `${d.getMonth() + 1}`.padStart(2, '0');
  return `${year}-${month}`;
}

export function mockPayrollAggregate(req: MinimalRequest): MockPayrollAggregate {
  const period = req.params?.get('period') ?? '';
  const gross = 42000;
  const employerContributions = 8602.8;
  const employeeSocial = 5758.2;
  const pit = 2456;
  const net = Math.round((gross - employeeSocial - pit) * 100) / 100;
  const available = period === shiftPeriod(0) || period === shiftPeriod(-1);
  if (!available) {
    return {
      period,
      available: false,
      gross: 0,
      employerContributions: 0,
      employeeSocial: 0,
      pit: 0,
      net: 0,
      computedAt: '',
    };
  }
  return {
    period,
    available: true,
    gross,
    employerContributions,
    employeeSocial,
    pit,
    net,
    computedAt: `${lastDayOf(period)}T18:30:00Z`,
  };
}

export function mockPostPayroll(req: MinimalRequest): MockAutoPostResult {
  const period = req.params?.get('period') ?? '';
  ensureAutoPostPeriodOpen(period, 'payroll');
  const body = (req.body as Record<string, unknown>) ?? {};
  const gross = Number(body['gross']) || 42000;
  const employer = Number(body['employerContributions']) || 8602.8;
  const social = Number(body['employeeSocial']) || 5758.2;
  const pit = Number(body['pit']) || 2456;
  const result: MockAutoPostResult = {
    source: 'payroll',
    period,
    posted: 0,
    skipped: 0,
    blocked: 0,
    reasons: [],
    entries: [],
  };
  const net = Math.round((gross - social - pit) * 100) / 100;
  const zus = Math.round((social + employer) * 100) / 100;
  const postings: MockJournalPosting[] = [
    { accountNumber: '404', description: 'Wynagrodzenia brutto', debit: gross, credit: 0 },
    { accountNumber: '405', description: 'Składki ZUS pracodawcy', debit: employer, credit: 0 },
    { accountNumber: '231', description: 'Wynagrodzenia do wypłaty', debit: 0, credit: net },
    { accountNumber: '220', description: 'Rozrachunki z ZUS', debit: 0, credit: zus },
    { accountNumber: '225', description: 'Zaliczka PIT-4', debit: 0, credit: pit },
  ];
  materializeAutoEntry(period, 'payroll', period, `Lista płac ${period}`, `LP/${period}`, postings, result);
  return result;
}
